import PropTypes from "prop-types";
import { memo, useCallback } from "react";
import CustomSelect from '../Dropdown/CustomSelect.jsx';

const CustomSelectSearch = (props) => {
  const {
    options = [],
    onChange = () => {},
    value = null,
    name = "",
    isDisabled = false,
    isMulti = false,
    labelName = "",
    containerClassName,
    errorMessage = "",
    errorClassName = "",
    error = false,
    customlabelClassName = "",
    labelClassName = "",
  } = props;

  const handleOnChange = useCallback(
    (selected) => {
      onChange(selected[0]);
    },
    [onChange]
  );

  const normalizeValue = (val) => {
    if (!val) {
      return [];
    }
    // If the value is already an array of objects with { value, label }
    if (Array.isArray(val) && val.every((item) => item.value && item.label)) {
      return val;
    }
    // If the value is a single string like 'Option 1'
    if (typeof val === "string") {
      const foundOption = options.find(
        (option) => option.label === val || option.value === val
      );
      return foundOption ? [foundOption] : [];
    }
    // If the value is a single object { value: 'option1', label: 'Option 1' }
    if (val.value && val.label) {
      return [val];
    }
    return [];
  };
  return (
    <div
      className={`${
        containerClassName
          ? containerClassName
          : "frmgroup default-input col-lg-6"
      }`}
    >
      {/* {labelName && <label>{labelName}</label>} */}
      <div className={`frmhead ${labelClassName}`}>
        {labelName && (
          <label className={customlabelClassName}>{typeof labelName === 'string' && labelName.endsWith('*') ? <>{labelName.slice(0, -1)}<span className="RedHighlight">*</span></> : labelName} </label>
        )}
        {error && (
          <div className={`error ${errorClassName}`}>{errorMessage}</div>
        )}
      </div>
      <div
        className={`dropdown bootstrap-select ${error ? "TypeHeadBorder" : ""}`}
      >
        <CustomSelect
          options={options}
          onChange={handleOnChange}
          defaultSelected={normalizeValue(value)}
          placeholder={name}
          selectContainerClassName={"w-100"}
          isDisabled={isDisabled}
          multiSelect={isMulti ? isMulti : false}
          isError={error}
        />
      </div>
    </div>
  );
};

export default memo(CustomSelectSearch);

CustomSelectSearch.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string,
    }),
    PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.any,
        label: PropTypes.string,
      })
    ),
  ]),
  name: PropTypes.string,
  isDisabled: PropTypes.bool,
  isMulti: PropTypes.bool,
  labelName: PropTypes.string,
  containerClassName: PropTypes.string,
  errorMessage: PropTypes.string,
  errorClassName: PropTypes.string,
  error: PropTypes.bool,
  customlabelClassName: PropTypes.string,
  labelClassName: PropTypes.string,
};



